/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function GraduationCap(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M180,209.59229a118.30523,118.30523,0,0,0,16-8.4668V240a8,8,0,0,1-16,0ZM120.94141,92.23535a7.99969,7.99969,0,0,0,3.29394,10.82324L171.00049,128,188,118.93359,131.76465,88.94141A7.99776,7.99776,0,0,0,120.94141,92.23535Zm130.82324-3.29394-120-64a7.99984,7.99984,0,0,0-7.5293,0l-120,64a7.99956,7.99956,0,0,0,0,14.11718L28,115.73315v49.721a16.05975,16.05975,0,0,0,3.19434,9.59326C39.11914,185.59277,69.51953,220,128,220a128.69017,128.69017,0,0,0,52-10.45557V132.7998L171.00049,128,128,150.93359,39.83643,103.91284l-.05713-.03052L25,96,128,41.06641,231,96l-14.7793,7.88232-.05713.03052L188,118.93359l3.76465,2.00782A8.10305,8.10305,0,0,1,196,128v73.06665a110.42518,110.42518,0,0,0,28.80469-26.01831A16.05929,16.05929,0,0,0,228,165.4541v-49.721l23.76465-12.67456a7.99956,7.99956,0,0,0,0-14.11718Z" />
    </Svg>
  );
}

export default GraduationCap;
